import { Route, Routes } from "react-router-dom";
import AppsError from "./apps-error";
import Survey from "./survey";

const SurveyRouter = () => {
  return (
    <Routes>
      <Route path="/:id" element={<Survey />} />
      <Route path="/" element={<AppsError />} />
    </Routes>
  );
};

export default SurveyRouter;
